var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRelationship(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 160,
    height: 160,
    viewBox: "0 0 160 160",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1405_20617)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M95.5267 84.4839H63.4707C50.0307 85.7132 39.5 97.0119 39.5 110.777C39.5 123.924 49.108 124.569 61.6867 124.569C63.0573 124.569 64.4653 124.561 65.9053 124.561H93.0973C94.5293 124.561 95.9373 124.569 97.3107 124.569C109.889 124.569 119.5 123.927 119.5 110.777C119.5 97.0119 108.967 85.7106 95.5267 84.4839Z",
    fill: "#4B4B4B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.5001 80.5159C92.0967 80.5159 102.308 70.3044 102.308 57.7079C102.308 45.1114 92.0967 34.8999 79.5001 34.8999C66.9036 34.8999 56.6921 45.1114 56.6921 57.7079C56.6921 70.3044 66.9036 80.5159 79.5001 80.5159Z",
    fill: "#4B4B4B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.7767 84.4839H63.7207C50.2807 85.7132 39.75 97.0119 39.75 110.777C39.75 123.924 49.358 124.569 61.9367 124.569C63.3073 124.569 64.7153 124.561 66.1553 124.561H93.3473C94.7793 124.561 96.1873 124.569 97.5607 124.569C110.139 124.569 119.75 123.927 119.75 110.777C119.75 97.0119 109.217 85.7106 95.7767 84.4839Z",
    fill: "#4B4B4B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.7501 80.5159C92.3467 80.5159 102.558 70.3044 102.558 57.7079C102.558 45.1114 92.3467 34.8999 79.7501 34.8999C67.1536 34.8999 56.9421 45.1114 56.9421 57.7079C56.9421 70.3044 67.1536 80.5159 79.7501 80.5159Z",
    fill: "#4B4B4B"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1405_20617"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 81,
    height: 91,
    fill: "white",
    transform: "translate(39.5 34.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRelationship);
export default __webpack_public_path__ + "static/media/relationship.d081075d126bd64e169c547eeadc435b.svg";
export { ForwardRef as ReactComponent };